/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appEconomic_viewer$ref: FragmentReference;
declare export opaque type appEconomic_viewer$fragmentType: appEconomic_viewer$ref;
export type appEconomic_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +economicEnabled: ?boolean,
  |},
  +$refType: appEconomic_viewer$ref,
|};
export type appEconomic_viewer$data = appEconomic_viewer;
export type appEconomic_viewer$key = {
  +$data?: appEconomic_viewer$data,
  +$fragmentRefs: appEconomic_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appEconomic_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "economicEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a4025ea5d7b88f9725c5289139913851';

module.exports = node;
